

import { BidiModule } from '@angular/cdk/bidi';
import { OverlayModule } from '@angular/cdk/overlay';
import { PlatformModule } from '@angular/cdk/platform';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MwcNoAnimationModule } from 'mwc/core/no-animation';
import { MwcOutletModule } from 'mwc/core/outlet';
import { MwcIconModule } from 'mwc/icon';

import { MwcMenuDividerDirective } from './menu-divider.directive';
import { MwcMenuGroupComponent } from './menu-group.component';
import { MwcMenuItemDirective } from './menu-item.directive';
// import { MwcMenuDirective } from './menu.directive';
// import { MwcSubmenuInlineChildComponent } from './submenu-inline-child.component';
// import { MwcSubmenuNoneInlineChildComponent } from './submenu-non-inline-child.component';
import { MwcSubMenuTitleComponent } from './submenu-title.component';
import { MwcMenuDirective, MwcSubmenuInlineChildComponent, MwcSubmenuNoneInlineChildComponent,  MwcSubMenuComponent } from './submenu.component';

@NgModule({
  imports: [BidiModule, CommonModule, PlatformModule, OverlayModule, MwcIconModule, MwcNoAnimationModule, MwcOutletModule],
  declarations: [
    MwcMenuDirective,
    MwcMenuItemDirective,
    MwcSubMenuComponent,
    MwcMenuDividerDirective,
    MwcMenuGroupComponent,
    MwcSubMenuTitleComponent,
    MwcSubmenuInlineChildComponent,
    MwcSubmenuNoneInlineChildComponent
  ],
  exports: [MwcMenuDirective, MwcMenuItemDirective, MwcSubMenuComponent, MwcMenuDividerDirective, MwcMenuGroupComponent]
})
export class MwcMenuModule {}
